import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { IAppContext, withAppContext } from 'src/App/shared/app-context';
import { ILogoStateInfo } from 'src/App/shared/logo.types';
import { DebuggerInstance } from 'src/App/shared/debugger';
import { LogoGalleryUrl } from 'src/App/shared/constants';
import { LogoUpload } from './logo-upload.component';
import { localization, LocHelperInstance, langChangedName } from 'src/App/shared/localization/localization';

export enum UploadState {
    Upload,
    UploadFailed,
    Review,
    DtpResult
}

export interface ILogoProcessingResult {
    logoId: string;
}

export interface ILogoUploadControllerProps extends RouteComponentProps<void> {
    appContext: IAppContext
}

interface IState {
    uploadState: UploadState;
    uploadError: string | null;
    logoInfo: ILogoStateInfo | ILogoProcessingResult | null; 
    showDtp: boolean;
    dtpResult: boolean;
}

class LogoUploadControllerComponent extends React.PureComponent<ILogoUploadControllerProps,IState> {
    private langUpdateHandle = () => {this.props.appContext.setTitle(localization.uploadLoc.title); };
    
    constructor(props: ILogoUploadControllerProps) {
        super(props);
        
        DebuggerInstance.log('LogoUploadController');

        this.state = {
            uploadState: UploadState.Upload,
            uploadError: null,
            logoInfo: null,
            showDtp: false,
            dtpResult: false
        };
    }

    public componentDidMount() {
        LocHelperInstance.langChanged.addListener(langChangedName, this.langUpdateHandle);

        this.langUpdateHandle();
    }

    public componentWillUnmount() {
        LocHelperInstance.langChanged.removeListener(langChangedName, this.langUpdateHandle);
    }

    private handleUploadSuccess(logoId: string) : void {
        this.props.appContext.onLogochanged(logoId);
        this.props.appContext.closeApp();
        // this.props.history.push(LogoGalleryUrl);
    }

    private handleUploadFail(): void {
        this.props.history.push(LogoGalleryUrl);
    }

    public render() {
        return (
            <LogoUpload
                onUploadSuccess={(logoId: string) => this.handleUploadSuccess(logoId)}
                onUploadFail={() => this.handleUploadFail()}
            />
        );
    }        
}

export const LogoUploadController = withAppContext(LogoUploadControllerComponent);



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-upload/logo-upload.controller.tsx